module.exports = __webpack_public_path__ + "static-v-shop/1765575532973/img/bg-product.30b97be6.jpg";